import { LocalStorageKeyEnum } from "src/app/localStorage.key.enum";
import { AsyncDropdown } from "../../async-dropdown";

export class PersonProfileCompany {
  identifier: string;
  l3: AsyncDropdown;
  l1: AsyncDropdown;
  directSuperior: AsyncDropdown;
  coordinator: AsyncDropdown;
  l2: AsyncDropdown;
  //noDirectSuperior: boolean;
  companyOperationalOffice: AsyncDropdown;
  dateStart = localStorage.getItem(LocalStorageKeyEnum.PERSONA_START_DATE) !== 'null' ? localStorage.getItem(LocalStorageKeyEnum.PERSONA_START_DATE) : null;
  dateEnd: string;
  seniority: string;
  status: string;
  managerL1: AsyncDropdown;
  managerL2: AsyncDropdown;
  managerL3: AsyncDropdown;
}